import { render } from 'preact';
import { App } from './App';
import './styles/signaletique.css';

const racine = document.getElementById('racine');
if (racine === null) {
  throw new Error("L'élément racine #racine est absent de index.html.");
}

render(<App />, racine);

/**
 * Installation de la coquille hors ligne.
 *
 * Échouer ici ne doit rien empêcher : l'application reste utilisable tant que
 * l'onglet est ouvert. Le service worker n'ajoute que la survie au redémarrage
 * sans réseau — ce qui, sur un pont, est précisément ce qui compte.
 */
if ('serviceWorker' in navigator) {
  globalThis.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((cause: unknown) => {
      console.warn('Coquille hors ligne non installée', cause);
    });
  });
}
